<div class="main">
    <div class="group">
        <div class="search-icon">
            <img src="../../../../assets/svg-pages/search-icon.svg" />
        </div>
        <div class="icon-404">
            <img src="../../../../assets/svg-pages/icon-404.svg" />
        </div>
        <div class="page-not-found"><span>Page Not Found</span></div>
        <div class="navigate">
            <span>Please try to navigate to another page OR <br> go back to Home Page.</span>

        </div>
        <div class="BTN" (click)="navigateToHomePage()">
            <div class="back-to-home">Back to Home</div>
            <div class="frame-2"></div>
        </div>
    </div>
</div>